document.addEventListener('shopify:section:load', initAmareDrawer);
document.addEventListener('DOMContentLoaded', initAmareDrawer);

function initAmareDrawer() {
  const burger = document.querySelector('.amare-header__hamburger');
  const drawer = document.querySelector('.amare-mobile-drawer');
  const overlay = document.querySelector('.amare-mobile-drawer__overlay');
  const closeBtn = document.querySelector('.amare-mobile-drawer__close');

  if (!burger || !drawer) return;

  // Remove duplicate event listeners by cloning
  const newBurger = burger.cloneNode(true);
  burger.parentNode.replaceChild(newBurger, burger);

  const newCloseBtn = closeBtn ? closeBtn.cloneNode(true) : null;
  if (closeBtn) closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);

  const newOverlay = overlay ? overlay.cloneNode(true) : null;
  if (overlay) overlay.parentNode.replaceChild(newOverlay, overlay);

  function closeDrawer() {
    drawer.classList.remove('active');
    document.body.classList.remove('drawer-open');
    newBurger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
  }

  newBurger.addEventListener('click', () => {
    const isOpen = drawer.classList.contains('active');
    if (isOpen) {
      closeDrawer();
    } else {
      drawer.classList.add('active');
      document.body.classList.add('drawer-open');
      newBurger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
    }
  });

  if (newOverlay) newOverlay.addEventListener('click', closeDrawer);
  if (newCloseBtn) newCloseBtn.addEventListener('click', closeDrawer);
}
